import PropTypes from "prop-types";
import React, { type FC } from "react";

type Extension =
  | "jpeg"
  | "jpg"
  | "mp4"
  | "pdf"
  | "png"
  | "xls"
  | "ppt"
  | "pptx"
  | "doc"
  | "docx"
  | string;

const icons: Record<Extension, string> = {
  jpeg: "/assets/icons/icon-jpg.svg",
  jpg: "/assets/icons/icon-jpg.svg",
  mp4: "/assets/icons/icon-mp4.svg",
  pdf: "/assets/icons/icon-pdf.svg",
  png: "/assets/icons/icon-png.svg",
  svg: "/assets/icons/icon-svg.svg",
  xls: "/assets/icons/icon-xls.svg",
  xlsx: "/assets/icons/icon-xls.svg",
  ppt: "/assets/icons/icon-ppt.png",
  pptx: "/assets/icons/icon-ppt.png",
  doc: "/assets/icons/icon-doc.png",
  docx: "/assets/icons/icon-doc.png",
};

interface FileIconProps {
  extension?: Extension | null;
}

export const FileIcon: FC<FileIconProps> = (props) => {
  const { extension } = props;

  let icon: string;

  if (!extension) {
    icon = "/assets/icons/icon-other.svg";
  } else {
    icon = icons[extension] || "/assets/icons/icon-other.svg";
  }

  return <img alt={extension ?? ""} src={icon} width={48} height={48} />;
};

FileIcon.propTypes = {
  extension: PropTypes.string,
};
